module.exports = __webpack_public_path__ + "static/media/msg-confirmation.030b9a10.svg";